import React from 'react'

const Title = props => (
    <h1 className={`header1 ${props.className}`}>{props.title}</h1>
)

Title.defaultProps = {
    className: '',
    title: 'wrong title'
}

export default Title



// WEBPACK FOOTER //
// ./src/scripts/components/Title.jsx